window.sizeCalculatorApp = {
    bestSizeSku: '',
    metricOn: document.getElementById('enable_metric').checked,
    recommendation: {mtn: 'M', cty: 'L', step_thru: 'L', bash: 'M'},
    user: [800, 787, 1727],
    sizeChartType: 'cty',
    mm_to_inch: 0.0393701,
    cm_to_inch: 0.393701,
    defaultValues: {
        metric: {
            label: window.metricStrings.cm,
            step: 1,
            inseem: { max: 97, min: 64, value: 80 },
            cockpit: { max: 94, min: 64, value: 79 },
            height: { max: 198, min: 147, value: 173 },
            'height--ft': { max: 0, min: 0, value: 0, label: '' },
            'height--in': { max: 198, min: 147, value: 173 },
        },
        imperial: {
            label: window.metricStrings.inches,
            step: 1,
            inseem: { max: 38, min: 25, value: 31.5, step: .5 },
            cockpit: { max: 37, min: 25, value: 31, step: .5 },
            height: { max: 78, min: 58, value: 68 },
            'height--ft': { max: 6, min: 4, value: 5, label: window.metricStrings.feet },
            'height--in': { max: 11, min: 0, value: 8 },
        }
    },
    getBestSize: () => {
        // Define the nominal sizes for [Crotch, Thumb Reach, Height]
        const sizesByType = {
            mtn: {
                S: [725, 697, 1611],
                M: [780, 746, 1733],
                L: [840, 790, 1814],
                XL: [885, 847, 1883],
            },
            cty: {
                S: [701, 684, 1608],
                M: [769, 733, 1698],
                L: [817, 769, 1765],
                XL: [875, 826, 1862],
            },
            step_thru: {
                S: [701, 684, 1608],
                M: [769, 733, 1698],
                L: [817, 769, 1765],
            },
            bash: {
                S: [701, 696, 1608],
                M: [769, 745, 1698],
                L: [817, 781, 1765],
                XL: [875, 838, 1862],
            }
        }

        const sizes_json = sizesByType[sizeCalculatorApp.sizeChartType];

        // sizes
        const sizeOptionsByType = {
            default: ["XL", "L", "M", "S"],
            step_thru: ["L", "M", "S"],
        }
        const sizes = sizeOptionsByType[sizeCalculatorApp.sizeChartType] || sizeOptionsByType.default;

        // Define upper and lower limits of the crotch height [XL, L, M, S] (step_thru [L, M, S])
        const upperLowerByType = {
            mtn: {
              upper: [978, 953, 908, 834],
              lower: [860, 835, 775, 725],
            },
            cty: {
              upper: [908, 880, 820, 753],
              lower: [795, 780, 730, 695],
            },
            step_thru: {
              upper: [880, 820, 753],
              lower: [780, 730, 695],
            },
            bash: {
              upper: [908, 880, 835, 780],
              lower: [845, 830, 780, 745],
            },
        }

        const upper = upperLowerByType[sizeCalculatorApp.sizeChartType].upper;
        const lower = upperLowerByType[sizeCalculatorApp.sizeChartType].lower;

        // Define the weights of each variable
        // Should sum to 1
        const weights = [.80, .15, .5];

        // Check the bounderies of the user crotch to rule out
        // any size range that isn't included
        let i;
        const possible = [];
        for (i = 0; i < upper.length; i++) {
            if (upper[i] > sizeCalculatorApp.user[0] && lower[i] < sizeCalculatorApp.user[0]) {
                possible.push(sizes[i])
            }
        }
        // if the user crotch is not within the range for any of the sizes, recommend the smallest or largest size accordingly
        if (!possible.length) {
            if (sizeCalculatorApp.user[0] > upper[0]) {
                possible.push(sizes[0])
            } else {
                possible.push(sizes[upper.length - 1])
            }
        }

        // Calculate the distances
        function eucDist(array1, array2) {
            let i;
            let inside = 0;
            for (i = 0; i < array1.length; i++) {
                inside += weights[i] * Math.pow(array1[i] - array2[i], 2)
            }
            return Math.sqrt(inside);
        }

        let j;
        let BestSize = '';
        let BestDistance = 1000000;
        for (j = 0; j < possible.length; j++) {
            // get anchor for that size
            anchor_j_name = possible[j];
            anchor_j = sizes_json[anchor_j_name];

            // calculate distance
            dist_j = eucDist(sizeCalculatorApp.user, anchor_j);
            if (dist_j < BestDistance) {
                BestSize = possible[j];
                BestDistance = dist_j;
            }
        }
        sizeCalculatorApp.setBestSizeInventoryStatus(BestSize);
    },
    setBestSizeInventoryStatus: (size) => {
        const sizeOptionsFieldset = document.querySelector('fieldset.size');
        if (!sizeOptionsFieldset) return;
        const bestSize = size || sizeCalculatorApp.recommendation[sizeCalculatorApp.sizeChartType].toLowerCase();
        const bestSizeOptionEl = Array.from(sizeOptionsFieldset.querySelectorAll('input'))
            .filter(option => option.value.toLowerCase() === bestSize.toLowerCase());
        const bestSizeOptionFirstEl = bestSizeOptionEl[0];
        if (!bestSizeOptionFirstEl) return;
        const bestSizeSku = bestSizeOptionFirstEl.getAttribute('data-variant-sku');
        const bestSizeVariantData = window.product_app.getCustomVariantDataBySku(bestSizeSku);
        const updateButtonEl = document.getElementById('update-and-close');
        if (sizeCalculatorApp.recommendedSizeEl) {
            sizeCalculatorApp.recommendedSizeEl.innerText = bestSize;
        }
        sizeCalculatorApp.bestSizeSku = bestSizeSku;
        Array.from(document.querySelectorAll('.sjs_size-inventory-badges .inventory-status__badge')).forEach(statusEl => {
            if (statusEl.classList.contains(bestSizeVariantData.stockLevel)) {
                if (statusEl.classList.contains('upcoming-stock')) {
                    Array.from(document.querySelectorAll(`.upcoming-stock-status`)).forEach(statusSpanEl => {
                        if (statusSpanEl.classList.contains(bestSizeSku)) {
                            statusSpanEl.classList.add('show');
                        } else {
                            statusSpanEl.classList.remove('show');
                        }
                    });
                }
                statusEl.classList.add('show');
            } else {
                statusEl.classList.remove('show');
            }
        });
        updateButtonEl.disabled = bestSizeVariantData.stockLevel === 'out-of-stock';
    },
    updateAndClose: () => {
        document.querySelector(`input[data-variant-sku="${sizeCalculatorApp.bestSizeSku}"]`).click();
        document.querySelector('.ModalClose-size-calculator').click();
    },
    setSizeInputsToMetricOrImperialValues: () => {
        let values = {};
        let ftInputElementDisplay;
        const ftInputElements = document.querySelectorAll('input[id*="--ft"]');
        const sizeInputElements = document.querySelectorAll('input.size-input');
        if (sizeCalculatorApp.metricOn){
            values = sizeCalculatorApp.defaultValues['metric'];
            ftInputElementDisplay = 'none';
        } else {
            values = sizeCalculatorApp.defaultValues['imperial'];
            ftInputElementDisplay = 'block';
        }
        ftInputElements.forEach(ftInputEl => {
            ftInputEl.parentNode.style.display = ftInputElementDisplay;
        });
        sizeInputElements.forEach((el) => {
            const inputType = el.id.indexOf('size-range') > -1
                ? 'range'
                : 'input';
            const sizeType = el.id.split(`size-${inputType}--`)[1];
            el.step = values[sizeType].step || values.step;
            el.max = values[sizeType].max;
            el.min = values[sizeType].min;
            el.value = values[sizeType].value;
            if (inputType === 'range') {
                el.parentElement.querySelector('.tickmarks').remove();
                el.parentElement.addTickmarks();
                sizeCalculatorApp.triggerEventsManually(el, 'input');
                el.setAttribute('aria-valuetext', `${el.value} ${values[sizeType].label || values.label}`);
            } else {
                el.nextElementSibling.innerText = values[sizeType].label || values.label;
            }
        });
    },
    triggerEventsManually: (el, type) => {
        // IE9+ and other modern browsers
        if ('createEvent' in document) {
            const e = document.createEvent('HTMLEvents');
            e.initEvent(type, false, true);
            el.dispatchEvent(e);
        } else {
            // IE8
            const e = document.createEventObject();
            e.eventType = type;
            el.fireEvent('on' + e.eventType, e);
        }
    },
    enforceInputMinMax: (el) => {
        if (parseFloat(el.value) > parseFloat(el.max)) {
            el.value = el.max;
        } else if (parseFloat(el.value) < parseFloat(el.min)) {
            el.value = el.min;
        }
    },
    getTotalSizeValue: (key) => {
        let total = 0;
        const allInputElementsBySizeType = document.querySelectorAll(`input[id*="size-input--${key}"]`);
        if (allInputElementsBySizeType.length === 2) {
            const ftToInches = parseFloat(allInputElementsBySizeType[0].value) * 12;
            const inches = parseFloat(allInputElementsBySizeType[1].value);
            total = ftToInches + inches;
        } else {
            total = allInputElementsBySizeType[0].value;
        }
        return total;
    },
    setFtInInputs: (key, totalSizeValue) => {
        const ftInputEl = document.querySelector(`input[id*="size-input--${key}--ft"]`);
        const inInputEl = document.querySelector(`input[id*="size-input--${key}--in"]`);
        if (sizeCalculatorApp.metricOn) {
            ftInputEl.value = 0;
            inInputEl.value = totalSizeValue;
        } else {
            const feet = Math.floor(totalSizeValue / 12);
            ftInputEl.value = feet;
            inInputEl.value = totalSizeValue - (feet * 12);
        }
    },
    calculatingTimeoutId: null,
    handleSizeInputElUpdateEvent: (el) => {
        const userIndexMap = { inseem: 0, cockpit: 1, height: 2 };
        const defaultValues = sizeCalculatorApp.metricOn ? sizeCalculatorApp.defaultValues['metric'] : sizeCalculatorApp.defaultValues['imperial'];
        const inputType = el.id.indexOf('size-range') > -1
            ? 'range'
            : 'input';
        const sizeType = el.id.split(`size-${inputType}--`)[1];
        const sizeTypeParts = sizeType.split('--');
        const inputValueNumber = parseFloat(el.value);
        let rangeInput;
        let totalSizeValue;

        // Prevent the range and number inputs from getting set below/above their min/max values
        sizeCalculatorApp.enforceInputMinMax(el);
        // Collect the data needed to sync up the range input with the number input based on what type was changed by the user
        if (inputType === 'range') {
            totalSizeValue = inputValueNumber;
            rangeInput = el;
            // Sync up the range input with the number input. Note: Height value (in imperial) is currently the only range input that needs to break down into ft/in
            if (sizeType === 'height') {
                sizeCalculatorApp.setFtInInputs(sizeTypeParts[0], totalSizeValue);
            } else {
                document.querySelector(`input[id*="size-input--${sizeType}"]`).value = totalSizeValue;
            }
        } else {
            totalSizeValue = sizeCalculatorApp.getTotalSizeValue(sizeTypeParts[0]);
            if (totalSizeValue < defaultValues[sizeTypeParts[0]].min) {
                totalSizeValue = defaultValues[sizeTypeParts[0]].min;
                sizeCalculatorApp.setFtInInputs(sizeTypeParts[0], totalSizeValue);
            } else if (totalSizeValue > defaultValues[sizeTypeParts[0]].max) {
                totalSizeValue = defaultValues[sizeTypeParts[0]].max;
                sizeCalculatorApp.setFtInInputs(sizeTypeParts[0], totalSizeValue);
            }
            rangeInput = document.querySelector(`input[id="size-range--${sizeTypeParts[0]}"]`);
            rangeInput.value = totalSizeValue;
        }
        // Set ADA aria-valuetext label to tie together the value with either Centimeters or Inches
        rangeInput.setAttribute('aria-valuetext', `${totalSizeValue} ${defaultValues[sizeTypeParts[0]].label || defaultValues.label}`);
        // update the user selected values
        if (sizeCalculatorApp.metricOn){
            sizeCalculatorApp.user[userIndexMap[sizeTypeParts[0]]] =  Math.round(totalSizeValue * sizeCalculatorApp.cm_to_inch / sizeCalculatorApp.mm_to_inch);
        } else {
            sizeCalculatorApp.user[userIndexMap[sizeTypeParts[0]]] = Math.round(totalSizeValue / sizeCalculatorApp.mm_to_inch);
        }
        if (!sizeCalculatorApp.calculatingTimeoutId) {
            sizeCalculatorApp.recommendedSizeEl.closest('.best-fit-name-with-availability').classList.add('updating');
            sizeCalculatorApp.recommendedSizeEl.innerHTML = '<div class="processing">' +
                '  <svg version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 12 52 24" enable-background="new 0 0 0 0" xml:space="preserve">' +
                '    <circle fill="#fff" stroke="none" cx="6" cy="24" r="6"><animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/></circle>' +
                '    <circle fill="#fff" stroke="none" cx="26" cy="24" r="6"><animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"/></circle>' +
                '    <circle fill="#fff" stroke="none" cx="46" cy="24" r="6"><animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/></circle>' +
                '  </svg>' +
                '</div>';
        }
        clearTimeout(sizeCalculatorApp.calculatingTimeoutId);
        sizeCalculatorApp.calculatingTimeoutId = setTimeout(() => {
            sizeCalculatorApp.getBestSize();
            sizeCalculatorApp.recommendedSizeEl.closest('.best-fit-name-with-availability').classList.remove('updating');
            sizeCalculatorApp.calculatingTimeoutId = null;
        }, 600);
    },
    bindEventListeners: () => {
        document.getElementById('enable_metric').addEventListener('change', function() {
            sizeCalculatorApp.metricOn = document.getElementById('enable_metric').checked;
            sizeCalculatorApp.setSizeInputsToMetricOrImperialValues();
            sizeCalculatorApp.setBestSizeInventoryStatus();
            sizeCalculatorApp.recommendedSizeEl = document.getElementById('recommendedSize'); // Note: This initially comes from the shopify page content for size-calculator
            if (sizeCalculatorApp.recommendedSizeEl) {
                sizeCalculatorApp.recommendedSizeEl.innerText = sizeCalculatorApp.recommendation[sizeCalculatorApp.sizeChartType];
            }
        });
        Array.from(document.querySelectorAll('.instruction-toggle'))
            .forEach(instructionToggleEl => {
                instructionToggleEl.addEventListener(
                    'click',
                    (e) => {
                        const elementId = `size_instructions--${e.currentTarget.getAttribute('id').split('--')[1]}`;
                        e.currentTarget.classList.toggle('open');
                        $(`#${elementId}`).slideToggle();
                    }
                );
            });
        Array.from(document.querySelectorAll('input.size-input.field__input'))
            .forEach((sizeInputEl, index) => {
                // The blur event is needed for the number inputs to allow backspace functionality and to allow user to insert two digits.
                sizeInputEl.addEventListener('blur', (event) => {
                    sizeCalculatorApp.handleSizeInputElUpdateEvent(event.target);
                });
                sizeInputEl.addEventListener('keyup', (event) => {
                    if (event.key === 'Enter') {
                      event.target.blur();
                    }
                });
            });
        Array.from(document.querySelectorAll('input.size-input.size-range'))
            .forEach((sizeInputEl, index) => {
                sizeInputEl.addEventListener('input', (event) => {
                    sizeCalculatorApp.handleSizeInputElUpdateEvent(event.target);
                });
            });
    },
    init: () => {
        sizeCalculatorApp.bindEventListeners();
        const sizeCalculatorPopupEl = document.querySelector('.product-popup-modal.size-calculator');
        if (sizeCalculatorPopupEl) {
            sizeCalculatorApp.sizeChartType = sizeCalculatorPopupEl.getAttribute('data-size-chart-type');
        }
        $('.size_instructions').slideToggle();
        if (sizeCalculatorApp.metricOn) {
            sizeCalculatorApp.setSizeInputsToMetricOrImperialValues();
        }
        sizeCalculatorApp.setBestSizeInventoryStatus();
        sizeCalculatorApp.recommendedSizeEl = document.getElementById('recommendedSize'); // Note: This initially comes from the shopify page content for size-calculator
        if (sizeCalculatorApp.recommendedSizeEl) {
            sizeCalculatorApp.recommendedSizeEl.innerText = sizeCalculatorApp.recommendation[sizeCalculatorApp.sizeChartType];
        }
    }
};
document.addEventListener("DOMContentLoaded", function() {
    sizeCalculatorApp.init();
});
